<svg class="h-5 w-5 transition-transform duration-200 ease-out" [ngClass]="{ 'rotate-90': isOpen }" viewBox="0 0 20 20"
    fill="currentColor" aria-hidden="true">
    <path fill-rule="evenodd"
        d="M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z"
        clip-rule="evenodd" />
</svg>